import { useEffect, useState } from 'react';
import styles from './CasePage.module.scss';
import { useNavigate } from 'react-router-dom';
import { useNavMenuStore } from '@/store/useNavMenuStore';
import { BackButton } from '@/components/BackButton';
import { FlipTimeDisplay } from './FlipTimeDIsplay';
import arrow from '../../assets/Icons/master.svg?url';
import caseIcon from '../../assets/Icons/caseIcon.svg?url';
import starIcon from '../../assets/Icons/starwithborder.svg?url';
import {
  getCaseData,
  getCases,
  getLeaderboard,
  getLimit,
} from '@/api/modules/Case/case';
import CaseModal from './CaseModal';
import { Loader } from '@/components/Loader/Loader';
import useAttemptsStore from '@/store/AttemptsStore';
import { TimeDisplay } from '@/utils/TimeDisplay';
import CaseLeaderboard from './CaseLeaderboard';
import useLimitStore from '@/store/LimitStore';

const CasePage = () => {
  const navigate = useNavigate();
  const [isCaseOpen, setIsCaseOpen] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [activeCase, setActiveCase] = useState<any>({});
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState('');
  const setAttempts = useAttemptsStore((state) => state.setAttempts);
  const blocked = useAttemptsStore((state) => state.blocked);
  const setBlocked = useAttemptsStore((state) => state.setBlocked);
  const [leaderboard, setLeaderboard] = useState([]);
  const setLimit = useLimitStore((state) => state.setLimit);

  useEffect(() => {
    const fetchCases = async () => {
      setLoading(true);
      try {
        const res = await getCases();
        console.log(res, 'DATAA');
        setCases(res.events);

        console.log(res.events, 'CASES');
        const activeCase = res.events.filter(
          (item: any) => item.status === 'active',
        );
        console.log(activeCase, 'ACTIVE CASE');

        if (activeCase.length === 0) {
          console.error('Нет активных кейсов');
          setLoading(false);
          return;
        }

        const activeId = activeCase[0].safe_event_id;
        const caseData = await getCaseData(activeId);
        setActiveCase(caseData);
        console.log(caseData, 'CASE DATA');

        // Загружаем URL фоновой картинки с бэкенда
        if (caseData?.details?.image_url) {
          setBackgroundImageUrl(caseData.details.image_url);
        }

        if (caseData?.user) {
          setAttempts(caseData.user.attempts_today || 0);
          setIsSubscribed(
            caseData.user.subscribed_utils?.is_subscribed?.subscribed || false,
          );
          if (caseData.user.is_opened_today) {
            setBlocked(true);
          }
          if (caseData.user.attempts_left === 0) {
            setBlocked(true);
          }
        }

        const leaderinfo = await getLeaderboard(activeId);
        console.log(leaderinfo, 'LEADERBOARD');
        setLeaderboard(leaderinfo);
      } catch (error) {
        console.error('Ошибка при загрузке данных:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCases();
  }, []);

  useEffect(() => {
    const fetchLimit = async () => {
      const limit = await getLimit();
      console.log(limit.data.onclick, 'LIMIT');
      setLimit(limit.data.onclick);
    };
    fetchLimit();
  }, []);

  useEffect(() => {
    useNavMenuStore.getState().setVisibility(false);

    return () => {
      useNavMenuStore.getState().setVisibility(true);
    };
  }, []);

  const handleBackClick = () => {
    navigate('/');
  };
  const handleCaseClick = () => {
    setIsCaseOpen(true);
  };
  const handleArchiveClick = () => {
    navigate('/case/archive');
  };

  const handleLeaderboardUpdate = async () => {
    try {
      const activeCase = cases.filter(
        (item: any) => item.status === 'active',
      ) as any[];
      if (activeCase.length > 0) {
        const activeId = activeCase[0].safe_event_id;
        const leaderinfo = await getLeaderboard(activeId);
        setLeaderboard(leaderinfo);
      }
    } catch (error) {
      console.error('Ошибка при обновлении лидерборда:', error);
    }
  };

  if (loading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <BackButton onClick={handleBackClick} />
      <div className={styles.content}>
        <div className={styles.timer}>
          <div className={styles.timerText}>
            До конца турнира <br /> осталось:
          </div>
          <div className={styles.timerValue}>
            <FlipTimeDisplay endDate={activeCase?.ends_at || ''} />
          </div>
        </div>
        <div
          className={styles.banner}
          style={{
            backgroundImage: backgroundImageUrl
              ? `url(${backgroundImageUrl})`
              : 'url(../../../public/casebg.webp)',
          }}
        >
          {cases.length > 1 && (
            <div className={styles.archiveButton} onClick={handleArchiveClick}>
              <div>Архив</div>
              <img src={arrow} alt="" />
            </div>
          )}
          <div className={styles.bannerInfoBottom}>
            <div>
              <img src={caseIcon} alt="" />
              <div>Вместимость сейфа:</div>
            </div>
            <div>
              <img src={starIcon} alt="" />
              <div>
                {activeCase?.main_prize?.amount?.toLocaleString() || '0'}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          {blocked ? (
            <button
              className={`${styles.buttonBreak} ${styles.blocked}`}
              disabled={true}
            >
              <div className={styles.blockedContent}>
                <div className={styles.blockedTimer}>
                  Повтор через{' '}
                  <TimeDisplay endDate={activeCase?.ends_at || ''} />
                </div>
              </div>
            </button>
          ) : (
            <button className={styles.buttonBreak} onClick={handleCaseClick}>
              Взломать сейф!
            </button>
          )}
        </div>
        <CaseLeaderboard leaderboard={leaderboard} />
        <CaseModal
          open={isCaseOpen}
          onClose={() => setIsCaseOpen(false)}
          isSubscribed={isSubscribed}
          setIsSubscribed={setIsSubscribed}
          caseData={activeCase}
          onLeaderboardUpdate={handleLeaderboardUpdate}
        />
      </div>
    </div>
  );
};

export default CasePage;
